import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiCurrencyRate } from '@app/packages/api/v2/types/entities'

export class ApiCurrencyRateFabricator extends ApiFabricator<ApiCurrencyRate> {
  protected getBase = (): ApiCurrencyRate => ({
    type: 'currency_rates',
    id: ApiFabricator.getId('currency_rates'),
    attributes: {
      from: 'RUB',
      to: 'USD',
      rate: 90,
    },
  })
}
